var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex justify-between" },
        [
          _c(
            "GrmBtn",
            {
              attrs: { color: "gray" },
              on: {
                click: function ($event) {
                  return _vm.SET_VIEW("testbank__exam_list")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("testBank.goBack")))]
          ),
          _c("GrmBtn", { on: { click: _vm.onCreateExam } }, [
            _vm._v(_vm._s(_vm.$t("common.register"))),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "mt-4 -mx-3 py-8 px-10 bg-gray-100 lg:mt-10 lg:-mx-10 lg:px10",
        },
        [
          _c("div", { staticClass: "flex flex-col gap-y-6" }, [
            _c("div", [
              _c(
                "p",
                {
                  staticClass:
                    "w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6",
                },
                [_vm._v(_vm._s(_vm.$t("testBank.style")))]
              ),
              _c(
                "div",
                { staticClass: "mt-3 flex gap-x-2" },
                [
                  _c(
                    "GrmBtn",
                    {
                      attrs: {
                        color:
                          _vm.testbankObj.examType === "QUIZ"
                            ? "purple"
                            : "gray",
                        hoverColor: "none",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSelectExamType("QUIZ")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("testBank.write")))]
                  ),
                  _c(
                    "GrmBtn",
                    {
                      attrs: {
                        color:
                          _vm.testbankObj.examType === "SURVEY"
                            ? "green"
                            : "gray",
                        hoverColor: "none",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSelectExamType("SURVEY")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("testBank.survey")))]
                  ),
                ],
                1
              ),
            ]),
            _c("div", [
              _c(
                "div",
                {
                  staticClass:
                    "w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6",
                },
                [_vm._v(_vm._s(_vm.$t("setting.name.title")))]
              ),
              _c(
                "p",
                { staticClass: "mt-3" },
                [
                  _c("GrmTextField", {
                    ref: "examTitle",
                    staticClass: "w-full",
                    attrs: {
                      bgColor: "white",
                      placeholder: _vm.isMobile
                        ? _vm.$t("testBank.alert.shortName")
                        : _vm.$t("testBank.alert.name"),
                    },
                    model: {
                      value: _vm.testbankObj.examTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.testbankObj, "examTitle", $$v)
                      },
                      expression: "testbankObj.examTitle",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm.testbankObj.examType === "QUIZ"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "border-t border-gray-300 pt-6 flex flex-col items-center",
                  },
                  [
                    _c("p", { staticClass: "font-bold" }, [
                      _vm._v(_vm._s(_vm.$t("testBank.answerTable"))),
                    ]),
                    _c("TestbankResultCorrectTable", {
                      staticClass: "mt-4",
                      attrs: { questionList: _vm.testbankObj.questionList },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
      _c("TestbankQuestionList", {
        attrs: {
          type: "edit",
          testbankObj: _vm.testbankObj,
          questionList: _vm.testbankObj.questionList,
        },
        on: { updateQuestionList: _vm.onUpdateQuestionList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }